var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm12":""}},[_vm._v("A página não existe.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }